const SvgSmallShowDetails = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_16506_62323)">
        <g clipPath="url(#clip1_16506_62323)">
          <path
            d="M5.99658 2.25C3.16668 2.25 0.673219 4.21148 0.0117201 6.78174C-0.0130144 6.87809 0.00153825 6.98031 0.0521767 7.06593C0.102815 7.15155 0.185391 7.21355 0.28174 7.23828C0.378088 7.26302 0.480316 7.24846 0.565934 7.19782C0.651552 7.14719 0.713548 7.06461 0.738283 6.96826C1.30828 4.75352 3.51649 3 5.99658 3C8.47668 3 10.6919 4.75414 11.2617 6.96826C11.2865 7.06461 11.3485 7.14719 11.4341 7.19782C11.5197 7.24846 11.6219 7.26302 11.7183 7.23828C11.8146 7.21355 11.8972 7.15155 11.9478 7.06593C11.9985 6.98031 12.013 6.87809 11.9883 6.78174C11.3266 4.21086 8.82649 2.25 5.99658 2.25ZM6.00049 4.25C4.67047 4.25 3.58447 5.336 3.58447 6.66602C3.58447 7.99603 4.67047 9.08252 6.00049 9.08252C7.33051 9.08252 8.41699 7.99603 8.41699 6.66602C8.41699 5.336 7.33051 4.25 6.00049 4.25Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_16506_62323">
          <rect width="12" height="12" fill="white" />
        </clipPath>
        <clipPath id="clip1_16506_62323">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgSmallShowDetails;
